import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { IKeyPairValue } from 'src/app/interface/IKeyValuePair';

@Injectable({
  providedIn: 'root'
})
export class AwardInfoService {

  constructor(private http: HttpClient) { }

  /*
     * Handle Http operation that failed.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      // this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  postAwardInformation(saveRequestBody: any) {
    return this.http.post(environment.serviceURL + environment.postAwardInformation, saveRequestBody, { headers: { 'Content-Type': 'application/json; charset=utf-8' } });
  }

  postAgreementDetails(saveRequestBody: any) {
    return this.http.post(environment.serviceURL + environment.postAgreementDetails, saveRequestBody, { headers: { 'Content-Type': 'application/json; charset=utf-8' } });
  }

  postSaveAgreementCountry(saveRequestBody: any) {
    return this.http.post(environment.serviceURL + environment.postSaveAgreementCountry, saveRequestBody, { headers: { 'Content-Type': 'application/json; charset=utf-8' } });
  }

  postSaveAgreementRegion(saveRequestBody: any) {
    return this.http.post(environment.serviceURL + environment.postSaveAgreementRegion, saveRequestBody, { headers: { 'Content-Type': 'application/json; charset=utf-8' } });
  }

  postSaveDonorContact(saveRequestBody: any) {
    return this.http.post(environment.serviceURL + environment.postSaveDonorContact, saveRequestBody, { headers: { 'Content-Type': 'application/json; charset=utf-8' } });
  }

  postSaveAgreementDonorContact(saveRequestBody: any) {
    return this.http.post(environment.serviceURL + environment.postSaveAgreementDonorContact, saveRequestBody, { headers: { 'Content-Type': 'application/json; charset=utf-8' } });
  }

  postAgreementTechnicalArea(saveRequestBody: any) {
    return this.http.post(environment.serviceURL + environment.postAgreementTechnicalArea, saveRequestBody, { headers: { 'Content-Type': 'application/json; charset=utf-8' } });
  }

  postCountryImplementation(saveRequestBody: any) {
    return this.http.post(environment.serviceURL + environment.postCountryImplementation, saveRequestBody, { headers: { 'Content-Type': 'application/json; charset=utf-8' } });
  }

  deleteCountryImplementation(delDonorContactIds: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json'
      }),
      body: delDonorContactIds
    };
    return this.http.delete<any>(environment.serviceURL + environment.deleteCountryImplementation, httpOptions).pipe(
      tap(), catchError(this.handleError<any>('delete donor contacts')));
  }

  getAgreementInformationDetails(agreementId: any) {
    return this.http.get<any>(environment.serviceURL + environment.getAgreementInformationDetails + agreementId);
  }

  getSPAccessToekn() {

    const input = new FormData();
    input.append('grant_type', 'client_credentials');
    input.append('client_id', environment.spClientId + '@' + environment.spTenantId);
    input.append('client_secret', environment.spClientSecret);
    input.append('resource', environment.spResource);

    return this.http.post<any>(environment.spGetTokenUrl, input);
  }

  getSPFiles(token: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;odata=verbose',
        Accept: 'application/json;odata=verbose',
        'Authorization': 'Bearer ' + token
      })
    };
    return this.http.get<any>(environment.spGetFiles, httpOptions);
  }

  uploadSPFiles(token: string, webUrl: string, requestBody: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;odata=verbose',
        'Accept': 'application/json;odata=verbose',
        'Authorization': 'Bearer ' + token
      })
    };
    return this.http.post<any>(webUrl, requestBody, httpOptions);
  }


  readFileInfo(token: string, webUrl: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json;odata=verbose',
        'Accept': 'application/json;odata=verbose',
        'Authorization': 'Bearer ' + token
      })
    };

    return this.http.get<any>(webUrl, httpOptions);
  }

  downloadFile(token: string, webUrl: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        //   'Content-Type': 'application/json;odata=verbose',
        //   'Accept': 'application/json;odata=verbose',
        'Authorization': 'Bearer ' + token
      })
    };

    return this.http.get<any>(webUrl, httpOptions);
  }

  postAgreementActivity(saveRequestBody: any) {
    return this.http.post(environment.serviceURL + environment.postAgreementActivity, saveRequestBody, { headers: { 'Content-Type': 'application/json; charset=utf-8' } });
  }

  postDataMigration(saveRequestBody: any) {
    return this.http.post(environment.serviceURL + environment.postDataMigration, saveRequestBody, { headers: { 'Content-Type': 'application/json; charset=utf-8' } });
  }

  documentDataMigration(saveRequestBody: any) {
    return this.http.post(environment.serviceURL + environment.documentDataMigration, saveRequestBody, { headers: { 'Content-Type': 'application/json; charset=utf-8' } });
  }

  deleteAgreementCountry(delCountryIds: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json'
      }),
      body: delCountryIds
    };
    return this.http.delete<any>(environment.serviceURL + environment.deleteAgreementCountry, httpOptions).pipe(
      tap(), catchError(this.handleError<any>('delete agreement country')));
  }

  deleteAgreementRegion(delRegionIds: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json'
      }),
      body: delRegionIds
    };
    return this.http.delete<any>(environment.serviceURL + environment.deleteAgreementRegion, httpOptions).pipe(
      tap(), catchError(this.handleError<any>('delete agreement region')));
  }

  deleteDonorContact(delDonorContactIds: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json'
      }),
      body: delDonorContactIds
    };
    return this.http.delete<any>(environment.serviceURL + environment.deleteDonorContact, httpOptions).pipe(
      tap(), catchError(this.handleError<any>('delete donor contact')));
  }

  deleteAgreementDonorContact(delDonorContactIds: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json'
      }),
      body: delDonorContactIds
    };
    return this.http.delete<any>(environment.serviceURL + environment.deleteAgreementDonorContact, httpOptions).pipe(
      tap(), catchError(this.handleError<any>('delete donor contacts')));
  }

  deleteAgreementActivity(delActivityIds: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json'
      }),
      body: delActivityIds
    };
    return this.http.delete<any>(environment.serviceURL + environment.deleteAgreementActivity, httpOptions).pipe(
      tap(), catchError(this.handleError<any>('delete agreement activity')));
  }

  deleteTechnicalArea(delActivityIds: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json'
      }),
      body: delActivityIds
    };
    return this.http.delete<any>(environment.serviceURL + environment.deleteTechnicalArea, httpOptions).pipe(
      tap(), catchError(this.handleError<any>('delete technical area')));
  }

  getDonorInformation(donorId: any) {
    return this.http.get<any>(environment.serviceURL + environment.getDonorInformation + donorId);
  }

  getAwardContacts(donorId: any) {
    return this.http.get<any>(environment.serviceURL + environment.getAwardContacts + donorId);
  }

  postDonorInformation(saveRequestBody: any) {
    return this.http.post(environment.serviceURL + environment.postDonorInformation, saveRequestBody, { headers: { 'Content-Type': 'application/json; charset=utf-8' } });
  }

  postDonorContacts(saveRequestBody: any) {
    return this.http.post(environment.serviceURL + environment.postDonorContact, saveRequestBody, { headers: { 'Content-Type': 'application/json; charset=utf-8' } });
  }

  deleteDonorInfoEntryContacts(delDonorContactIds: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json'
      }),
      body: delDonorContactIds
    };
    return this.http.delete<any>(environment.serviceURL + environment.deleteDonorInfoEntryContacts, httpOptions).pipe(
      tap(), catchError(this.handleError<any>('delete donor contact')));
  }

  getAllCountry(agreementId: string) {
    return this.http.get<IKeyPairValue[]>(environment.serviceURL + environment.getAllCountry + agreementId);
  }

  getRegionCountry(agreementId: string) {
    return this.http.get<IKeyPairValue[]>(environment.serviceURL + environment.getRegionCountry + agreementId);
  }

  getIsAwardYearUsed(agreementId: string, awardYear: any, getAwardYear: any) {
    return this.http.get<any>(environment.serviceURL + environment.getIsAwardYearUsed + agreementId + '/' + awardYear + '/' + getAwardYear);
  }
}
